import clsx from 'clsx';
import React from 'react';
import './UiExampleToolbar.css';
import { UiToolbar, UiFlex, UiIconMaterial, UiText, UiButton } from '../..';
export function UiExampleToolbar() {
    return (React.createElement("div", { className: clsx('UiExampleToolbar') },
        React.createElement(UiToolbar, null,
            React.createElement(UiFlex, null,
                React.createElement(UiButton, { icon: React.createElement(UiIconMaterial, null, "arrow_back"), size: 1 }),
                React.createElement(UiText, { weight: 2 }, "Title")),
            React.createElement(UiFlex, null,
                React.createElement(UiButton, { icon: React.createElement(UiIconMaterial, null, "edit"), size: 1 }),
                React.createElement(UiButton, { icon: React.createElement(UiIconMaterial, null, "cached"), size: 1 })))));
}
